import { createContext, Dispatch } from 'react';
import { StateActions } from 'session/state/actions';
import { globalState, IGlobalState } from 'session/state/state';

export const GlobalContext = createContext<{
    state: IGlobalState;
    dispatch: Dispatch<StateActions>;
}>({
    state: globalState,
    dispatch: () => undefined
});
